// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AMkb","content":"styles_content__12pjA","tableWrap":"styles_tableWrap__e8887"};